<!-- Sidebar -->
<nav id="sidebar" class="{{classToggle}}">
  <div class="toggle-icon " (click)="toggleMenu()">
    <div class="{{barsVisible}}">
      <i id="sidebarCollapse">
        <mat-icon>{{iconMenu}}</mat-icon>
      </i>
    </div>
  </div>

  <ul class="list-unstyled components">
    <li [class.active]="router.url.endsWith('/')">
      <a routerLink="/home" class="item-menu" matTooltip="Dashboard">
        <mat-icon>dashboard</mat-icon>
        <span class="collapse in hidden-xs"> Dashboard </span>
      </a>
    </li>
    <li [class.active]="router.url.includes('/protocolo')">
      <a routerLink="/protocolo" class="item-menu" matTooltip="Novo Protocolo">
        <mat-icon>assignment</mat-icon>
        <span class="collapse in hidden-xs"> Novo Protocolo </span>
      </a>
    </li>
    <li [class.active]="router.url.includes('/acompanhamento')">
      <a class="item-menu" matTooltip="Acompanhamento" routerLink="/acompanhamento">
        <mat-icon>search</mat-icon>
        <span class="collapse in hidden-xs"> Acompanhamento </span>
      </a>
    </li>
    <li [class.active]="router.url.includes('/ausencia-temporaria')">
      <a routerLink="/ausencia-temporaria" class="item-menu" matTooltip="Ausência Temporária">
        <mat-icon>date_range</mat-icon>
        <span class="collapse in hidden-xs"> Ausência Temporária </span>
      </a>
    </li>
    <li [class.active]="router.url.includes('/rastrear-protocolo')">
      <a routerLink="/rastrear-protocolo" class="item-menu" matTooltip="Rastrear Protocolo">
        <mat-icon>list_alt</mat-icon>
        <span class="collapse in hidden-xs"> Rastrear Protocolo </span>
      </a>
    </li>
    <li *ngIf="exibirMenuAprovacaoComercial" [class.active]="router.url.includes('/aprovacao-comercial')">
      <a routerLink="/aprovacao-comercial" class="item-menu" matTooltip="Aprovação Comercial">
        <mat-icon>assignment_turned_in</mat-icon>
        <span class="collapse in hidden-xs"> Aprovação Comercial </span>
      </a>
    </li>
  </ul>

  <ul class="list-unstyled components notBorderBottom">
  </ul>
</nav>